import { State } from 'model/State';

export default (state: State) => state.cart.payload.ifSuccess((c) => c && c.items.length) || 0;
